import { Stack, Text } from '@ltvco/refresh-lib/theme';
import { useNavigate } from 'react-router-dom';

import { ChatPageContainerStack } from '..';

import { BillingSection } from './sections/BillingSection/BillingSection';
import { LoginInformation } from './sections/LoginInformation/LoginInformation';
import { NeedAssistance } from './sections/NeedAssistance/NeedAssistance';
import { PlanUsage } from './sections/PlanUsage/PlanUsage';
import { ProfileDetails } from './sections/ProfileDetails/ProfileDetails';

interface AccountPageV2Props {
  upgradePath?: string;
}

export const AccountPageV2 = ({ upgradePath }: AccountPageV2Props) => {
  const navigate = useNavigate();
  const onUpgradePlanClick = upgradePath
    ? () => navigate(upgradePath)
    : undefined;

  return (
    <ChatPageContainerStack>
      <Stack
        spacing={3.5}
        padding={2.5}
        paddingTop={1}
        width="100%"
        maxWidth="1100px"
      >
        <Text variant="h1">Account</Text>
        <PlanUsage upgradePath={upgradePath} />
        <ProfileDetails />
        <LoginInformation />
        <BillingSection />
        <NeedAssistance onUpgradePlanClick={onUpgradePlanClick} />
      </Stack>
    </ChatPageContainerStack>
  );
};
